import React from "react";
import PropTypes from "prop-types";

const CardLongText = ({ children = null, className }) => {
  return <div className={`card__text ${className}`}>{children}</div>;
};

CardLongText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default CardLongText;
